var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishingInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_1163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.0001C1 9.34321 2.34315 8.00006 4 8.00006H10C10.5523 8.00006 11 8.44778 11 9.00006V15.0001C11 15.5523 10.5523 16.0001 10 16.0001H4C2.34315 16.0001 1 14.6569 1 13.0001V11.0001ZM4 10.0001C3.44772 10.0001 3 10.4478 3 11.0001V13.0001C3 13.5523 3.44772 14.0001 4 14.0001H9V10.0001H4Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 7.95413C19 7.24667 18.2855 6.76291 17.6286 7.02565L11 9.6771V14.323L17.6286 16.9745C18.2855 17.2372 19 16.7535 19 16.046V7.95413ZM16.8858 5.1687C18.8564 4.38046 21 5.83174 21 7.95413V16.046C21 18.1684 18.8564 19.6197 16.8858 18.8314L9.62861 15.9285C9.24895 15.7767 9 15.409 9 15.0001V9.00006C9 8.59116 9.24895 8.22345 9.62861 8.07159L16.8858 5.1687Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.0001C6.55228 14.0001 7 14.3732 7 14.8334V18.1667C7 18.627 6.55228 19.0001 6 19.0001C5.44772 19.0001 5 18.627 5 18.1667V14.8334C5 14.3732 5.44772 14.0001 6 14.0001Z",
    fill: "#97A0A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 12.0001C23 13.6569 21.6569 15.0001 20 15.0001C20 13.0001 20 11.0001 20 9.00006C21.6569 9.00006 23 10.3432 23 12.0001Z",
    fill: "#97A0A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_1163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishingInfo);
export default __webpack_public_path__ + "static/media/PublishingInfo.261a08139dc721709a1103c6f5f77018.svg";
export { ForwardRef as ReactComponent };